import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import topTost from "../../utils/topTost";
import { fetchFormData } from "../../utils/options"; // Assuming this is your helper for form data fetch
import Settled2Header from "./Settled2Header";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";

const SettledAdd = ({ permission }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const today = new Date().toISOString().split("T")[0];
  const [form, setForm] = useState({
    id: "21",
    IsPaid: false,
    TransitionID: "",
    payouts: "",
    PayoutDate: today,
    payouts_type: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData();
      if (id) formData.append("id", id);
      formData.append("IsPaid", form.IsPaid ? 1 : 0);
      formData.append("TransitionID", form.TransitionID);
      formData.append("payouts", form.payouts);
      formData.append("PayoutDate", form.PayoutDate);
      formData.append("payouts_type", form.payouts_type);
      formData.append("created_by", userId);
      formData.append("moduleId", M_id);
      formData.append("userId", userId);
      // You can switch to your fetchFormData helper here for consistency:
      const url = id ? "update-payout" : "loan-inquiry/payout";
      const res = await fetchFormData(url, formData, "POST");

      if (res && res.success) {
        topTost({ title: "Payout saved successfully", icon: "success" });
        navigate(`/inquiry/settled-list?id=${M_id}`);
      } else {
        topTost({ title: "Failed to save payout", icon: "error" });
        console.error("Server error:", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
      topTost({ title: "An error occurred", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Settled2Header />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <div className="col-lg-12">
                <div className="card stretch stretch-full">
                  <hr className="mt-0" />
                  <div className="card-body general-info">
                    <>
                      <div className="mb-5 d-flex align-items-center justify-content-between">
                        <h5 className="fw-bold mb-0 me-4">
                          <span className="d-block mb-2">
                            {id ? "Edit Payout" : "Add Payout"}
                          </span>
                        </h5>
                      </div>

                      <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-md-6">
                          <Input
                            label="Transition ID"
                            name="TransitionID"
                            value={form.TransitionID}
                            onChange={handleChange}
                            placeholder="Enter Transition ID"
                            icon="feather-hash"
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <Input
                            label="Payout Amount"
                            name="payouts"
                            value={form.payouts}
                            onChange={handleChange}
                            placeholder="Enter Amount"
                            type="number"
                            icon="feather-cash"
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <Input
                            label="Payout Date"
                            name="PayoutDate"
                            type="date"
                            value={form.PayoutDate}
                            onChange={handleChange}
                            required
                            icon="feather-calendar"
                            min={today}
                          />
                        </div>

                        <div className="col-md-6">
                          <Input
                            label="Payout Type"
                            name="payouts_type"
                            value={form.payouts_type}
                            onChange={handleChange}
                            placeholder="Enter Payout Type"
                            icon="feather-tag"
                            required
                          />
                        </div>

                        <div className="row mb-3 align-items-center">
                          <div className="col-2">
                            <label className="form-label mb-0">Is Paid</label>
                          </div>
                          <div className="col-4 d-flex align-items-center">
                            <input
                              type="checkbox"
                              className="form-check-input me-2"
                              id="isPaidCheckbox"
                              checked={form.IsPaid}
                              onChange={(e) =>
                                handleChange("IsPaid", e.target.checked)
                              }
                            />
                            <label
                              className="form-check-label mb-0"
                              htmlFor="isPaidCheckbox"
                            >
                              Yes
                            </label>
                          </div>
                        </div>

                        <div className="col-md-12 d-flex justify-content-center">
                          <button
                            type="submit"
                            className="btn btn-lg btn-primary"
                            disabled={isSubmitting}
                          >
                            {isSubmitting
                              ? "Submitting..."
                              : id
                              ? "Update"
                              : "Submit"}
                          </button>
                        </div>
                      </form>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default SettledAdd;
